import envs from "../envs";

export const home = `/paravoce/cap-aluguel`;
export const mapaCondicoesGerais =
  "/AreaAberta/CapAluguel/CondicoesGerais/Condicoes-Gerais.json";

export const regrasAssistencia = `${envs.hostStaticCdn}/AreaAberta/CapAluguel/Regras_da_assistencia_Cap Aluguel.pdf`;

export default null;
